import * as React from 'react';
import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import ouiBase from '@goldwasserexchange/oui';
import ouiStyle from '@goldwasserexchange/oui-style';
import { UseGetFnProps } from '../../shared';
import { SearchKeysProps } from '../../shared/components/list/context/searchKeys/context';

export function DefaultRadioListInputBase(
  props: {
    fieldPath: string,
    dependenciesFieldPaths?: string[],
    type: Extract<ouiBase.Input.InputTypes, 'radio' | 'checkbox'>,
    elementLines?: ouiStyle.InStyle['lines'],
  } & SearchKeysProps & UseGetFnProps & ouiBase.List.ListProps & ouiBase.List.ListDataFilterAndSortProviderProps,
) {
  const {
    fieldPath,
    dependenciesFieldPaths = [],
    type,
    list,
    length,
    elementLines,
    useFilterFn,
    useSortFn,
    useGetFn,
    searchKeys,
  } = props;
  return (
    <RampWithNameTransform<
    {
      type: Extract<ouiBase.Input.InputTypes, 'radio' | 'checkbox'>,
      fieldPath: string,
      dependenciesFieldPaths: string[],
      elementLines?: ouiStyle.InStyle['lines'],
    } & SearchKeysProps & UseGetFnProps & ouiBase.List.ListProps
    >
      rampName="InputContextProvider"
      type={type}
      fieldPath={fieldPath}
      dependenciesFieldPaths={dependenciesFieldPaths}
      list={list}
      length={length}
      elementLines={elementLines}
      useFilterFn={useFilterFn}
      useSortFn={useSortFn}
      useGetFn={useGetFn}
      searchKeys={searchKeys}
    >
      <RampWithNameTransform rampName="InputContainer">
        <RampWithNameTransform rampName="InputContent" />
      </RampWithNameTransform>
    </RampWithNameTransform>
  );
}
